import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenCommunicate as ScreenCommunicateFemale } from '../../../OwnAI/screens/Communicate';
import { ScreenCommunicate as ScreenCommunicateMale } from '../../../OwnAIMan/screens/Communicate';
import { LayoutDataType } from '../../types';

export const ScreenCommunicate: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenCommunicateMale />;
  }

  return <ScreenCommunicateFemale />;
};
